import { render, staticRenderFns } from "./session-table.vue?vue&type=template&id=644fbede&scoped=true&"
import script from "./session-table.vue?vue&type=script&lang=ts&"
export * from "./session-table.vue?vue&type=script&lang=ts&"
import style0 from "./session-table.vue?vue&type=style&index=0&id=644fbede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644fbede",
  null
  
)

export default component.exports